import { useEffect, useId, useRef } from 'react';
import { createPortal } from 'react-dom';
import stile from './pruefhinweis-dialog.module.css';

export function pruefhinweisSatz(anzahl: number): string {
  return anzahl === 1
    ? '1 Prüfhinweis ist noch offen. Er wird bei der Freigabe entfernt.'
    : `${anzahl} Prüfhinweise sind noch offen. Sie werden bei der Freigabe entfernt.`;
}

export interface PruefhinweisDialogProps {
  anzahl: number;
  onBestaetigen(): void;
  /** Auch Esc und jedes andere Schliessen landen hier (`close`-Ereignis). */
  onZurueck(): void;
  /**
   * Springt nach dem Schliessen zum ersten Hinweis im Text. Ohne diesen Weg schloss "Zurück" nur
   * den Dialog, und die Hinweise liessen sich im langen Text uebersehen (Rueckmeldung 2026-10-13).
   */
  onZuDenHinweisen?(): void;
}

/**
 * Bestaetigung vor einer Freigabe mit offenen Pruefhinweisen (Spec 2026-10-12 §5.5). n8n entfernt
 * sie vor 7; wer freigibt, soll das wissen. Natives <dialog> per Portal an `body` wie die Lupe
 * (`bild-lupe.tsx`): Ereignisse aus dem Dialog laufen so weder in die Textflaeche noch in das
 * `onSubmit` des Formulars. "Zurück" steht zuerst im DOM -- `showModal` fokussiert den ersten
 * Knopf, der sichere Weg ist also der voreingestellte.
 */
export function PruefhinweisDialog({
  anzahl,
  onBestaetigen,
  onZurueck,
  onZuDenHinweisen,
}: PruefhinweisDialogProps) {
  const dialog = useRef<HTMLDialogElement>(null);
  const titelId = useId();
  useEffect(() => {
    const element = dialog.current;
    if (element && !element.open) element.showModal();
  }, []);
  return createPortal(
    <dialog ref={dialog} className={stile.dialog} aria-labelledby={titelId} onClose={onZurueck}>
      <h2 id={titelId} className={stile.titel}>
        Offene Prüfhinweise
      </h2>
      <p className={stile.satz}>{pruefhinweisSatz(anzahl)}</p>
      <div className={stile.aktionen}>
        <button
          type="button"
          className="eds-button eds-button--secondary"
          onClick={() => {
            dialog.current?.close();
            onZuDenHinweisen?.();
          }}
        >
          {onZuDenHinweisen ? 'Zu den Hinweisen' : 'Zurück'}
        </button>
        <button type="button" className="eds-button eds-button--primary" onClick={onBestaetigen}>
          Trotzdem freigeben
        </button>
      </div>
    </dialog>,
    document.body,
  );
}
